import React, { useEffect, useRef, useState } from "react";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { useVideo } from "../api/VideoProvider";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import "../styles/devices/mob_Home.css";
import { useTranslation } from "react-i18next";
import { Recorder } from "../components/stream/Recorder";
import { useStreamProvider } from "../api/StreamProvider";
import { RecorderReferenceVideo } from "../components/donateSentences/RecorderReferenceVideo";
import { IterativeFeedbackRecorderSentences } from "../components/donateSentences/IterativeFeedbackRecorderSentences"
import { ButtonGroup, Grid, FormControlLabel, Switch, Button, Paper } from "@material-ui/core";
import logoBlue from "../assets/logos/icon-libre.png";
import logoCopy from "../assets/logos/icon-copiar.png";
import { pDataProvider, pDB_user_roles } from "../utils/parameters";
import { useDataProvider } from "../api/DataProvider";
import { useVideoSyncMonitor } from "../api/VideoSyncMonitor";
import { useHistory } from "react-router-dom";
import json_answer from "../assets/csv/answer.json";
import { useCommProvider } from "../api/CommProvider";
import { saveVideo } from "../api/utils/webcam";
import { CameraTester } from "../components/stream/CameraTester";
import CachedIcon from '@mui/icons-material/Cached';
import { useTimerProvider } from '../api/TimerProvider';


const TEST_TIMER_DEFINITION = {
  'max':  20,
  'min':  2,
  'step':  2,
  'timer': 6
}


export function DonateSentence() {
  const { t } = useTranslation("global")
  
  const { comm_sendVideo, comm_donateSentence, comm_getDonateSentence } = useCommProvider();
  const history = useHistory();

  /* Devices */
  const [deviceId, setDeviceId] = useState({});
  /* Contexts */
  const { setFaceStatus, cameraPermissions, setCameraPermissions } = useVideo();
  const { token_id, currentUser, json_data_meaning, comm_getPublicURLVideoData } = useDataProvider();
  const [src_video, set_src_video] = useState(null);
  const [video_text , set_video_text ] = useState("");
  const [video_id, set_video_id ] = useState("");

  /* Snackbar */
  const [snack, setSnack] = useState({ open: false, text: "" });
  const [showFeedbackRecorder, setShowFeedbackRecorder] = useState(false);
  const [customTimerRecorder, setCustomTimerRecorder] = useState(TEST_TIMER_DEFINITION);
  const [isHideText, setIsHideText] = useState(false)

  const keys_avoid = [
    'a94bbc9b-4873-4403-ab55-67d13403c1f3',
    '0972ea2d-0818-4559-b222-09f22fb903cc',
    '48a93f6f-3c80-4fb0-b32b-91bd300e1eba',
    '74f7df9d-833a-4abf-aec9-f2d895c5aef4',
    '7da5a1d7-8b95-4c4d-a15b-b4253958e9d3',
    'ff70607e-6277-4e26-9aaa-096415263aca',
    '65e602d2-22b3-4ca4-ae20-b4dcf970c4dd',
    '4d649d32-9325-4769-b546-cd75fe789a42',
    '3744017e-8415-4e03-9860-5776a64b80db',
    '31e3947d-ce7a-488f-ae7c-dd9bb67f3566',
    '3b39e329-0a02-43a7-a5a2-af75f20f01e9',
    'fae43e5e-f13b-45db-b3f3-92bd2f38a1ed',
    '9cb6e4a0-11c4-45a7-b39d-f34d406ccd92',
    '99667b56-e74c-4c01-8d39-bfd54b7006de',
    'd59d60df-fd15-4aab-8ea6-e5a9950fb170',
    'aca283d9-d25f-4114-8509-fca2ed7498af',
    '5fd3e920-26b0-4181-b148-5c789f8e14f4',
    'f5a3680d-1f2e-4a31-ad4f-1acf27243c51',
    '5a54dd28-1323-4994-a1d1-55642ff50635',
    'bfe4aae6-bdb5-43cf-a73a-2d94f13e0857',
    'de1e5536-b5fa-4ceb-bc13-4da973e551b0',
    'aefea7ec-1f94-4c72-a666-48bf3466c93a',
    '06b8e98a-21bd-4595-bb05-7eb7f31c7f63',
    'eea5e49b-3f14-4337-8447-d05481474c87',
    '75e67008-2a59-4786-8ba4-1965e8db8944',
    '41f60f41-c8ac-4973-b600-bd94786cd08b',
    '5a4cca33-9552-484e-80df-7f9ff671881c',
    'c724e43c-1687-4ca3-821d-04fab717f60b',
    '8c16523e-f3e6-4846-b8a0-c8988a2448fe',
    'e1c4b552-341b-4f0f-aa1e-40af97cdd5b5',
    '820934f3-cb8e-48ee-b599-18c784289f30',
    'd81fd256-6eed-4320-8d92-0c0053bd89cb',
    'c5f5bb94-c1fa-457a-ae43-33c7f1f86ef2',
    '302084ee-199f-4f2b-8f95-a0c1afadb2c7',
    '69eb9b53-c69b-45c6-baa4-337c590f9495',
    'e1e814d5-893e-4100-952e-2d38db2a38a4',
    '22dc22a0-0019-478b-8239-df00f2a5ffc1',
    '1777c157-b90a-4161-9b4e-1d9bc84a5215',
    '795338a0-f81b-45e1-b62f-88b760512354',
    '879ef42c-e449-46f7-a317-3fe9d29ebdb2',
    'f9e38cd7-8dc0-48cb-93db-bac72e7f2314',
    '2f5df1b9-ce46-4cfd-9122-673f8b4f456a',
    '775c4045-e23a-46e9-8211-83125bb818ee',
    'f52b9ae6-aa7c-44dd-aa54-0fde7fe1e8a1',
    'f8c08535-ec9a-4a1c-ab45-1b718cf3aeb7',
    'd2d925cc-3bb1-4bfa-b3f3-36311beebd93',
    '108a6815-13e8-45e8-b47d-a4e95120fa25',
    '8cd9d7cc-d834-4753-9932-0725e5902f31',
    '267151ca-d103-4650-a58b-b9b7213ae9a9',
    '6597004e-9781-4e24-ba9b-6278127f5c37',
    'a6af3117-99a8-475c-9e9e-be28448b193c',
    '4f1449cc-911b-4460-99bd-9d93fbce72ca',
    '6e264375-f909-4839-8461-c3611594f59a',
    'd7b44b51-97c4-4861-b472-39263fba699c',
    'ef8e9ba9-0421-4962-97cf-c43c7b865c2d',
    '66bbdaab-ef02-45c8-a33f-72dd8da89596',
    'c65f3ab2-7b3e-4b48-b520-8c37f0e48526',
    '8606c871-6c73-4792-a60a-e9480abc1720',
    '5341a7d3-a4fa-4ef3-afc8-43a4d6462ff0',
    'cfe6b783-9b59-451b-9cce-88489cd66ad9',
    '473c4173-7614-4a9f-b281-80fa1457213b',
    '13736559-17f6-4e19-9fb5-07f399d124ec',
    'cf57f872-6fe6-4a65-86ef-3e0a235b9ae3',
    '581bf475-97b0-449c-a0e9-6b596f1a71dd',
    '686f5b35-ecac-4889-be8c-d0fd2fcd7739',
    '184936ee-ce4e-4f5a-863f-f0146b5ede5c',
    '44a59f3f-1692-4bb3-98fa-734b66d64f72',
    'd22b2543-2941-4f98-adee-555e350536e9',
    'f26f76f5-7409-4214-88c1-081275514710',
    'd9a01d7a-3b6c-4b61-9ff6-26cef24dddf4',
    'f57165e4-9a95-44fe-bb96-a6b577d2d67e',
    '2dbcecba-52b9-4022-80d0-2ebfd0399f38',
    '5065cb69-2a21-4743-b2dd-84f7250ce8eb',
    '46965ffc-f00d-455b-a2d7-57b2903140ca',
    'ce9d2cbd-115f-4bab-9843-764018ffa2ad',
    'a9bdfd51-3482-4146-941b-012d79902c6f',
    'cde63dc1-81ff-45e3-9d29-7b084f44a6e1',
    'b1fad850-7e41-42fb-a69a-9ca1e2c2a89c',
    '3ee7f523-a3d3-4330-bd4a-0afb64a862bc',
    '40b1913c-201b-43be-8b3e-6370f5a58fd0',
    '0c31278f-2a7b-4210-98b5-46f351bf1275',
    '17dc3445-ce0d-4be7-951f-3d79508906d6',
    '2e904e87-14ec-43aa-a39f-dcb263ef4bcf',
    'c5b8248c-3e8f-4710-97bb-38df9c166c65',
    'bf99dd91-98bd-4a74-a8f1-0f64b74acff3',
    '08807b80-f114-422f-a95d-7e9408b7207d',
    'be72a583-c425-4f54-9f4c-9898f905cdbd',
    '9e67f021-729f-4437-8f95-3a38facda92d',
    '6881e79d-a371-46c7-92f1-80c07a2ad587',
    'bea08a3a-7cb5-4daf-b323-6e46d8fff31f',
    'af2b89bd-9add-4885-a239-0c1f49128051',
    'd6b8d579-9d12-4d8e-94f7-89f651fce5a8',
    '33cd0b23-dce6-401a-9ea0-83e23ede06c6',
    '4475583f-15c4-4aab-a401-0157e8ea3161',
    '93e4ca9f-ca5b-4f2a-92ec-43852b346234',
    'ffbf4cf7-e738-4f16-8b1e-0e1e302a2d36',
    '0ca8fa17-eed0-45ab-97e4-4086b4be7a7c',
    '8edd415b-1014-48ca-9489-d4500bd424fd',
    '04b998e0-ff7c-4dd6-ac33-f14d5656da8d',
    '48ddbe4d-18b2-4efe-bd30-7ab3108eb462',
    'efc86f0e-1971-49bc-89f5-23f6382e19da',
    '03183797-3eaa-4acd-b87e-ecd8cfa9cae2',
    'ef5b5efe-f982-451c-9e84-06e6d3c15da1',
    'd0023ccc-a8a8-4942-8f9d-65fd4d9fab4f',
    '786d4b61-597f-427d-90b6-ef737c0ad42b',
    '02c6caaf-b4be-461c-a976-fea8e851876b',
    '69ba6ad1-0ebb-4a22-b286-42bd8b9a061a',
    '8d8bbf68-f7d5-4fa0-8926-07fece6e5b7b',
    '84ddbf79-e61c-4501-885f-9e9a2cf2fd89',
    '9e0b052c-b237-46e8-a9bc-3cae980c8af0',
    '2f6d2644-2fdf-4454-a5db-951684b47bae',
    '864f1013-4b85-4db8-b336-ad24dad9627c',
    '08f5a958-5b0a-4892-b476-56df3e67761f',
    '7f68ee27-38b4-4f70-b812-bf05421c9391',
    '1d2907ad-6e87-4c6f-aa71-1238abc5d11e',
    '4fce7462-b8d0-408f-82d5-f73246de3ef9',
    'a9171c5c-d73a-44ac-94c0-9bda553a30d2',
    '42bcfecb-f9c1-477b-9beb-2ef0cd7833a3',
    'fec89790-94a7-4c4d-9c8e-eb3ff00fa230',
    'd3b6c2b7-8fc2-4a82-9594-2db179ec631e',
    '59f269db-cf1c-4f47-b017-65ae029570bb',
    'a968e616-bb7e-4edc-8956-ec26b6eb04bb',
    '35f0146d-d4ca-4382-af60-367ac0051a7a',
    '86f18003-235c-4463-86b2-486d68501fd0',
    '60ed1b67-32e8-4fc2-b4a1-8d7f1b28ccbf',
    '04c0930c-2937-4e74-b2d3-324ad5e5f29d',
    '74f33ad1-140d-4168-8b73-e676b0907cbd',
    'b31f641d-44d1-4c93-8580-b9624bb6536d',
    '187d2f01-9da9-4562-9e92-2669867ae5be',
    'fde82c42-053b-4898-9dd1-d134295a1f64',
    '5fa24be3-a0d6-4f51-835c-786f77aab8b9',
    'c4530d48-3dd4-451e-9962-ff0219ecf15b',
    '0f0f1011-d148-4b9e-ae7f-e2bd87143e76',
    '968fad41-b114-40ec-ab0f-1e3dc544543a',
    '52512bc2-e854-488a-a335-4d6fb08494ca',
    '6c6a77a4-8069-4bdf-b3b5-277c856f8925',
    '0782262d-7552-4c13-a720-d376ce46d3c3',
    '0f63b503-8672-4934-9b45-a96a8e429df7',
    '669b5f98-1581-42aa-96b0-10cdf63b35f3',
    'b92e59ad-bab1-4ca3-a88a-12c7c35b68aa',
    'd1e7d6ce-0012-4ed0-8e8f-ebb12092e764',
    'a5db81da-6a8c-4660-9897-9a05b2123979',
    'b621c043-a1e7-4f07-8677-90465f6a4ed4',
    '4c595850-bd6f-44a1-b198-d948b0d02eeb',
    'c052a203-3bc9-42f8-895a-4a9fc2af3ba0',
    '7146b630-327e-4f47-9602-562f6d683dfe',
    '582c708d-4d21-4c25-8b82-4b711fb5e6ca',
    '94535323-d633-4be7-b97c-444855a994c0',
    'bb3a46c6-9e25-401f-905a-973bea281b05'
  ]

  const counterResponses = useRef(0)

  const { 
    streamMediaBlobUrl, 
    setStreamMediaBlobUrl, 
    getStreamIsRecording, 
    streamInitRecording, 
    streamStartRecording, 
    streamPauseRecording, 
    streamStopRecording 
  } = useStreamProvider();

  const {
    setForceStartVideoReference,
    setIsLoopVideoRecorder,
    isLoadedReference,
    setIsLoadedReference
  } = useVideoSyncMonitor();

  const { 
    setTimerSpeed
  } = useTimerProvider();


  /* Send video to server */
  async function send2ServerVideo(data) {
    console.log("🚀 ~ send2ServerVideo ~ send2ServerVideo DATA:", data)

    delete data['isActivated'];

    data['sentence_id'] = video_id
    data['sentence_label'] = video_text

    data['text_activated'] = isHideText
    

    const videoFile = await saveVideo(streamMediaBlobUrl);

    console.log("🚀 ~ send2ServerVideo ~ DATA2:", data)

    auxSign = await comm_donateSentence(token_id, currentUser, videoFile, data);
    console.log("🚀 ~ send2ServerVideo ~ comm_donateResponse:", comm_donateResponse)

  }

  // const getNewSample = () => {
  //   const keys = Object.keys(json_data_meaning);
  //   const randomDefinitionKey = keys[Math.floor(Math.random() * 10)];
  //   set_src_video(comm_getPublicURLVideoData(pDataProvider.dir_vid_definition, randomDefinitionKey));
  //   setIsLoopVideoRecorder(false)
  // }

  const getNewSample2 = async () => {
    // const keys = Object.keys(json_answer);
    // const filteredKeys = keys.filter(key => !keys_avoid.includes(key));

    // const randomDefinitionKey = filteredKeys[Math.floor(Math.random() * filteredKeys.length)];

    const response = await comm_getDonateSentence(token_id, currentUser)

    console.log("🚀 ~ getNewSample2 ~ response:", response)

    const sentence_id = response['id']
    const sentence_text = response['text']

    set_src_video(comm_getPublicURLVideoData(pDataProvider.dir_vid_answer, sentence_id));
    set_video_text(sentence_text)
    set_video_id(sentence_id)
    console.log("🚀 ~ getNewSample2 ~ sentence_id:", sentence_id)
    setIsLoopVideoRecorder(false)
    setIsLoadedReference(false)
  }

  useEffect(() => {
    getNewSample2()
    setTimerSpeed(1)
  }, []);

  const handleSend = (feedback) => {
    send2ServerVideo(feedback)
    getNewSample2()

    setShowFeedbackRecorder(false)
    setStreamMediaBlobUrl(undefined)

    // if (counterResponses.current > 1){   /// PROPORCIÓN 3 - 1

    //   history.push({pathname: "/donateResponse"});
    // }

    if (counterResponses.current > 0){   /// PROPORCIÓN 2 - 1

      history.push({pathname: "/donateResponse"});
    }

    counterResponses.current = counterResponses.current + 1
    console.log('INCREMENTAR CONTADOR : ', counterResponses.current)

  };
    
  const handleDiscard = (feedback) => {

    send2ServerVideo(feedback)

    setShowFeedbackRecorder(false)
    setStreamMediaBlobUrl(undefined)
    
    setForceStartVideoReference(new Date().getTime())
  };

  useEffect(() => {
      if (streamMediaBlobUrl !== undefined){
        setShowFeedbackRecorder(true)
      }
  }, [streamMediaBlobUrl]);


  useEffect(() => {
    console.log("🚀 ~ DonateSentence ~ isLoadedReference:", isLoadedReference)
  }, [isLoadedReference]);

  const forceGetNextVideo = () => {
    getNewSample2()
  };




  return (
    <HomeWrapper>
      
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className='sig_SignModal_PaperInfo' style={{backgroundColor: '#8500ff0d', border: "4px solid PURPLE", padding: '10px', width: '80%', borderRadius: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <a href={logoCopy} target="_blank" rel="noopener noreferrer">
            <img src={logoCopy} alt="description" style={{width: '50px', height: '50px'}}/>
          </a>
          <div className="sig_SignModal_PaperLine">
            <span className="sig_VersusMachine_InfoTitle" style={{fontSize: '30px', color: 'purple'}}> SIGNA IGUAL: </span>
            <span className="sig_VersusMachine_InfoContent" style={{fontSize: '30px'}}> Repite la respuesta.   </span>
          </div>
        </div> 
      </div>
      <Paper style={{ 
          backgroundColor: '#8500ff0d', 
          border: "4px solid purple", 
          position: 'relative', 
          display: 'flex', 
          flexDirection: 'row', 
          justifyContent: 'center', 
          transform: 'scale(1)', 
          margin: '-10px 1%', 
          padding: showFeedbackRecorder ? '0px 10px 50px 10px' : '0px 10px 10px 10px'
      }}>
        <div style={{ marginTop: '-5px', marginRight: '10px' }}>
          <RecorderReferenceVideo  src_video={src_video} video_text={video_text} setCustomTimerRecorder={setCustomTimerRecorder} hideControls={showFeedbackRecorder} isHideText={isHideText} setIsHideText={setIsHideText}/>
          {isLoadedReference==false && <Button style={{backgroundColor: '#f33333fc', borderRadius: '10px', marginTop: '-30px',  fontSize: '15px', color:'white', width: '100%', border: '3px solid red'}} onClick={forceGetNextVideo} > <CachedIcon style={{marginRight: '10px'}}/> RECARGAR VÍDEO  </Button>}
        </div>
        <div  style={{ marginLeft: '10px' }}>
          <Recorder action_send={() => setShowFeedbackRecorder(!showFeedbackRecorder)} customTimer={customTimerRecorder}/>
        </div>
        { showFeedbackRecorder &&
          <Paper style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '0px' }}>
            <IterativeFeedbackRecorderSentences action_send={handleSend} action_discard={handleDiscard}/>
          </Paper>
        }
        
      </Paper>
      <HelpSnackbar snack={snack} setSnack={setSnack} />
    </HomeWrapper>
  );

}